import Lenis from 'lenis';

let lenis = null;

export function initLenis(enabled) {
  if (!enabled || lenis) return;
  lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, touchMultiplier: 1.15 });
  window.__lenis = lenis;
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}

export function getLenis() {
  return lenis;
}

export function scrollToTarget(target) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (lenis) {
    if (reduced) lenis.scrollTo(target, { immediate: true });
    else lenis.scrollTo(target, { duration: 1.6, easing: (t) => 1 - Math.pow(1 - t, 4) });
    return;
  }
  const el = typeof target === 'string' ? document.querySelector(target) : target;
  if (el) el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  else window.scrollTo(0, 0);
}
